<template>
  <b-form @submit.stop.prevent="onSubmit">

    <b-form-group
      id="name-input"
      label="Nom *"
      label-for="name-input"
      class="bold-label"
      :invalid-feedback="form.lastName.invalidFeedback"
      :state="form.lastName.state"
    >
      <b-form-input
        id="name-input"
        v-model="form.lastName.value"
        type="text"
        maxlength="250"
        :state="form.lastName.state"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group
      class="bold-label"
      label="Prénom *"
      label-for="firstname-input"
      :state="form.firstName.state"
      :invalid-feedback="form.firstName.invalidFeedback"
    >
      <b-form-input
        id="firstname-input"
        v-model="form.firstName.value"
        type="text"
        maxlength="250"
        :state="form.firstName.state"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label="Adresse email *"
      label-for="username-input"
      class="bold-label"
      :state="form.username.state"
      :invalid-feedback="form.username.invalidFeedback"
    >
      <b-form-input
        id="username-input"
        v-model="form.username.value"
        type="email"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label="Téléphone"
      label-for="phone-input"
      class="bold-label"
      :state="form.phone.state"
      :invalid-feedback="form.phone.invalidFeedback"
    >
      <b-form-input
        id="phone-input"
        v-model="form.phone.value"
        type="tel"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label="Téléphone conjoint(e)"
      label-for="secondphone-input"
      class="bold-label"
      :state="form.secondPhone.state"
      :invalid-feedback="form.secondPhone.invalidFeedback"
    >
      <b-form-input
        id="secondphone-input"
        v-model="form.secondPhone.value"
        type="tel"
      ></b-form-input>
    </b-form-group>

    <PasswordCreationField
      :isEdit="edit"
      @passwordInfos="getPasswordInfos"
    ></PasswordCreationField>

    <b-form-checkbox
      v-if="!edit"
      id="send-email-cb"
      v-model="sendEmail"
      name="send-email-cb">
      Envoyer un email au propriétaire pour lui proposer de modifier son mot de passe
    </b-form-checkbox>

    <div :class="this.createHospitalization ? 'justify-content-between d-flex mt-2' : 'justify-content-end d-flex mt-2'">
      <b-button v-if="this.createHospitalization" variant="primary" class="mr-2" @click="skipUserCreation" :disabled="sendButtonDisabled">Propriétaire existant</b-button>
      <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Valider</b-button>
    </div>
  </b-form>
</template>

<script>
import PasswordCreationField from "../../components/PasswordCreationField";
import api from '../../services/api';

export default {
  name: "UserForm",

  components:{
    PasswordCreationField
  },
  props:{
    userId:{
      type: Number
    },
    createHospitalization: false,
    edit : false
  },

  data() {
    return {
      sendButtonDisabled: false,
      form: {
        lastName: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        firstName: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        username: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        phone: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        secondPhone: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        password: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },
      user: null,
      showPassword : false,
      sendEmail: true,
    }
  },

  created(){
    if (this.edit){
      this.fetchData()
    }
  },

  methods : {
    fetchData() {
      this.fetchUser()
    },

    fetchUser() {
      api
        .get(`/user/${this.userId}`)
        .then(response => {
          this.user = response.data
          this.setInitialValues()
        })
    },

    setInitialValues() {
      this.form.username.value = this.user.username
      this.form.firstName.value = this.user.firstName
      this.form.lastName.value = this.user.lastName
      this.form.phone.value = this.user.phone
      this.form.secondPhone.value = this.user.secondPhone
    },

    getPasswordInfos(state, invalidFeedBack, value){
      this.form.password.state = state;
      this.form.password.invalidFeedback = invalidFeedBack;
      this.form.password.value = value;
    },

    onSubmit() {
      this.sendButtonDisabled = true

      var data = new FormData();
      data.append('firstName', this.form.firstName.value);
      data.append('lastName',  this.form.lastName.value);
      data.append('username',  this.form.username.value);
      data.append('password',  this.form.password.value);
      if(this.form.phone.value != null) data.append('phone',  this.form.phone.value);
      if(this.form.secondPhone.value != null) data.append('secondPhone',  this.form.secondPhone.value);
      if(!this.edit) data.append('sendEmail', this.sendEmail);

      api({
        method:'POST',
        url: this.edit ? `/user/${this.user.id}` : 'user',
        data: data
      })
        .then((response) => {
          if(this.createHospitalization){
            this.$router.push({
              name: 'AnimalCreate',
              params: {
                createHospitalization : true,
                userId: response.data.id
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast()
              })
            })
          }else{
            this.$router.push({
              name: 'UserIndex'
            }, () => {
              this.$nextTick(() => {
                this.successToast()
              })
            })
          }
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    skipUserCreation() {
      this.$router.push({
          name: 'AnimalCreate',
          params: {
            createHospitalization : true,
          }
        })
    },

    successToast() {
      const message = this.edit ? 'Compte propriétaire modifié' : 'Propriétaire ajouté'
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserForm.vue